import { constant, Decoder, oneOf } from '@mojotech/json-type-validation'

import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'

export const displayLanguageTypeDecoder: Decoder<DisplayLanguageType> = oneOf(
  constant<DisplayLanguageType>('Japanese'),
  constant<DisplayLanguageType>('English')
)
